import {
  QueryKey,
  UseBaseQueryOptions,
  useQuery,
  QueryClientConfig,
} from 'react-query';

export interface IQueryClientConfig extends QueryClientConfig {}

export type QueryOptions<
  TQueryFnData = unknown,
  TError = unknown,
  TData = TQueryFnData,
  TQueryKey extends QueryKey = QueryKey,
> = Pick<
  UseBaseQueryOptions<TQueryFnData, TError, TData, TQueryFnData, TQueryKey>,
  | 'cacheTime'
  | 'enabled'
  | 'initialData'
  | 'keepPreviousData'
  | 'meta'
  | 'onError'
  | 'onSettled'
  | 'onSuccess'
  | 'placeholderData'
  | 'refetchInterval'
  | 'refetchOnWindowFocus'
  | 'retry'
  | 'staleTime'
>;

export const useCreateQuery = <
  TQueryFnData = unknown,
  TError = unknown,
  TData = TQueryFnData,
>(
  key: readonly unknown[],
  fetch: (params?: object | string) => Promise<TQueryFnData>,
  params?: object | string,
  options?: QueryOptions<TQueryFnData, TError, TData>,
) => {
  const query = useQuery<TQueryFnData, TError, TData>(
    [...key, params],
    () => fetch(params),
    options,
  );

  return {
    data: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    isSuccess: query.isSuccess,
    isRefetching: query.isRefetching,
    refetch: query.refetch,
  };
};
